export const StripeConfirmation = () => {
  return <main>confirmation page</main>;
};
